import Vue from "vue";
import Component from "vue-class-component";
import { ChartOverlayMetadata } from "&/types/layout-workspace/components/chart-overlay/chart-overlay-metadata.interface";
import { Prop } from "vue-property-decorator";

/**
 * 覆盖层控件的通用类
 *
 * @export
 * @class ChartOverlayConfigItemMixin
 * @extends {Vue}
 */
@Component
export class ChartOverlayConfigItemMixin extends Vue {
  // Props
  // ===================================================================
  @Prop({}) readonly setting!: any;

  get activeOverlayId(): string {
    return this.$stock.state["chart-overlay"].activeOverlayId;
  }
  get overlayMetadataList(): ChartOverlayMetadata[] {
    return this.$stock.state["chart-overlay"].metadataList;
  }

  /**
   * 根据 id 获取 overlay metadata
   *
   * @param {string} id
   * @returns {ChartOverlayMetadata}
   * @memberof ChartOverlayConfigItemMixin
   */
  getOverlayMetadataById(id: string): ChartOverlayMetadata {
    return this.overlayMetadataList.find((el) => el.id === id);
  }
}
